import { Popconfirm } from "antd";
import React from "react";

function POPConfirm({
  confirm,
  childrenprop,
  description,
  title,
  error,
}: {
  confirm?: () => void;
  childrenprop?: any;
  description: string;
  title: string;
  error: boolean;
}) {
  const cancel = (e: any) => {
    return e;
  };
  return (
    <>
      <Popconfirm
        title={title}
        description={description}
        onConfirm={confirm}
        onCancel={cancel}
        okText="Yes"
        cancelText="No"
        disabled={error}
        id="popconfirmbtn"
      >
        {childrenprop}
      </Popconfirm>
    </>
  );
}

export default POPConfirm;
